export default __webpack_public_path__ + "static/media/check.0fb6fb25.svg";